import { fabric } from 'fabric';

export function makeEllipse(canvas) {
    let ellipse, isDown, origX, origY;

    canvas.on('mouse:down', function(o){
        isDown = true;
        var pointer = canvas.getPointer(o.e);
        origX = pointer.x;
        origY = pointer.y;
        ellipse = new fabric.Ellipse({
            left: origX,
            top: origY,
            originX: 'left',
            originY: 'top',
            rx: pointer.x-origX,
            ry: pointer.y-origY,
            angle: 0,
            fill: '',
            stroke:'var(--theme-text-color)',
            strokeWidth:3,
        });
        canvas.add(ellipse);
    });

    canvas.on('mouse:move', function(o){
        if (!isDown) return;
        var pointer = canvas.getPointer(o.e);
        var rx = Math.abs(origX - pointer.x)/2;
        var ry = Math.abs(origY - pointer.y)/2;
        if (rx > ellipse.strokeWidth) {
            rx -= ellipse.strokeWidth/2
        }
        if (ry > ellipse.strokeWidth) {
            ry -= ellipse.strokeWidth/2
        }
        ellipse.set({ rx: rx, ry: ry});

        if(origX>pointer.x){
            ellipse.set({originX: 'right' });
        } else {
            ellipse.set({originX: 'left' });
        }
        if(origY>pointer.y){
            ellipse.set({originY: 'bottom'  });
        } else {
            ellipse.set({originY: 'top'  });
        }
        canvas.renderAll();
    });

    canvas.on('mouse:up', function(o){
        ellipse.setCoords();
        isDown = false;
    });

    canvas.renderAll();
}